export default {
  name : 'VSeparator',
  props: {
    color: {
      type   : String,
      default: '#cccccc'
    },

    height: {
      type   : String,
      default: '1px'
    },

    marginLeft: {
      type   : String,
      default: '16px'
    },

    marginRight: {
      type   : String,
      default: '16px'
    }
  }
}
